import PropTypes from 'prop-types';

const ModalBottomBar = ({ children = null }) => children;

ModalBottomBar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalBottomBar;
